export function omitProperty<T, K extends keyof T>(obj: T, key: K): Omit<T, K> {
  const { [key]: _, ...rest } = obj;
  return rest;
}

export function omitProperties<T, K extends keyof T>(obj: T, keys: K | K[]): Omit<T, K> {
  if (typeof keys === "string" || typeof keys === "number" || typeof keys === "symbol") {
    // If a single key is provided (not as an array)
    return omitProperty(obj, keys);
  }

  // For array of keys, reduce the object by omitting one property at a time
  return keys.reduce((result, key) => omitProperty(result, key) as any, { ...obj });
}
